import styled, { keyframes } from 'styled-components';
import InfiniteSlider from '../animation/InfiniteSlider';
import MainImage from '../../assets/images/sky_1.png';
import SkyImage1 from '../../assets/images/sky_2.png';
import SkyImage2 from '../../assets/images/sky_3.png';
import SkyImage3 from '../../assets/images/sky_4.png';
import SkyImage4 from '../../assets/images/sky_5.png';

const images = [
  { src: SkyImage1, text: 'Happy Wedding' },
  { src: SkyImage2, text: 'YOUNGJUN' },
  { src: SkyImage3, text: 'YUJIN' },
  { src: SkyImage4, text: '2025.06.01 SUN 11:00' },
];

const moveAnimation = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`;

const SkySection = () => {
  return (
    <StyledSection>
      <h2>
        <img src={MainImage} alt="푸른 초원 위에 영준과 유진" />
      </h2>
      <InfiniteSlider>
        {(isVisible) => (
          <StyledUl className={isVisible ? 'visible' : ''}>
            {[...images, ...images].map((item, index) => (
              <li key={index}>
                <img src={item.src} alt="" />
                <p>{item.text}</p>
              </li>
            ))}
          </StyledUl>
        )}
      </InfiniteSlider>
    </StyledSection>
  );
};

const StyledSection = styled.section`
  position: relative;
  overflow: hidden;
`;

const StyledUl = styled.ul`
  display: flex;
  gap: 2rem;
  padding: 3rem 2rem;
  font-size: 1.4rem;
  line-height: 2rem;
  font-weight: 400;
  text-align: center;
  width: max-content;

  li {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    width: 20rem;

    &:nth-child(even) {
      flex-direction: column-reverse;
    }

    img {
      width: 100%;
    }

    p {
      line-height: 11.5rem;
    }
  }

  &.visible {
    animation: ${moveAnimation} 15s linear infinite;
  }
`;

export default SkySection;
